import { useEffect } from 'react';

import { useFormikContext } from 'formik';

const FormObserver = <T,>({ onValueChange }: { onValueChange: (values: T) => void }) => {
  const { values } = useFormikContext<T>();
  useEffect(() => {
    onValueChange(values);
  }, [values, onValueChange]);
  return null;
};

export default FormObserver;
